import React from 'react'
import cn from 'classnames'

let TableHeaderSortable = ({ sort, setSort, field, children, ...props }) => {
  return (
    <th
      className={cn('text-nowrap', { 'bg-light': sort.field === field })}
      style={{ cursor: 'pointer', ...props.style }}
      onClick={() => {
        let order =
          sort.field !== field ? 'asc' : sort.order === 'asc' ? 'desc' : 'asc'

        setSort({ field, order })
      }}
    >
      {children}{' '}
      {sort.field !== field ? (
        <i className="fa fa-sort" />
      ) : (
        <i
          className={cn('fa', {
            'fa-sort-desc': sort.order === 'desc',
            'fa-sort-asc': sort.order === 'asc',
          })}
        />
      )}
    </th>
  )
}

export default TableHeaderSortable
